import { usePathname, useSearchParams } from '@framework/next/navigation';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import { usePageFiltersContext } from '@/creditflowresearch/application/PageFilters/PageFiltersContext';
import { UserPlanFeature } from '@creditflowresearch/user-plan/vo/IUserPlanResponse';
import { hasPlanTopicsAccess } from '../hasPlanTopicsAccess';
import { MARKET_OVERVIEW_PATTERNS, matchByPagePath } from '../grants/pagePatterns';

// TODO: remove when the European market opening period ends
export const useIsTileSubscribeLocked = (): boolean => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { checkAccessByFeature, products: planProductIds } = useUserPlanContext();
  const { pageFilters: { productIds } } = usePageFiltersContext();

  if (matchByPagePath(...MARKET_OVERVIEW_PATTERNS)({ pathname })) {
    return false;
  }

  return !hasPlanTopicsAccess({
    hasCommentaryAndDealFlow: checkAccessByFeature(UserPlanFeature.CommentaryAndDealFlow),
    planProductIds,
    productIds,
    markets: searchParams.get('markets') ?? undefined,
  });
};
